import React from 'react';
import { useCountdown } from './Countdown';
export function CountdownBar() {
  const timeLeft = useCountdown();
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 bg-red-600/95 backdrop-blur text-white py-1.5 px-3 shadow-sm text-xs sm:text-sm" data-id="element-61">
      <div className="max-w-4xl mx-auto flex flex-row items-center justify-center gap-2 sm:gap-3 text-center" data-id="element-62">
        <span className="font-medium flex items-center gap-1 opacity-90" data-id="element-63">
          ⚠️ Precio de lanzamiento cierra en:
        </span>
        <div className="flex items-center gap-1 font-bold tracking-tight" data-id="element-64">
          <span className="bg-white/15 px-1.5 py-0.5 rounded text-[11px] sm:text-xs" data-id="element-65">
            {pad(timeLeft.hours)}h
          </span>
          <span className="opacity-60" data-id="element-66">:</span>
          <span className="bg-white/15 px-1.5 py-0.5 rounded text-[11px] sm:text-xs" data-id="element-67">
            {pad(timeLeft.minutes)}m
          </span>
          <span className="opacity-60" data-id="element-68">:</span>
          <span className="bg-white/15 px-1.5 py-0.5 rounded text-[11px] sm:text-xs" data-id="element-69">
            {pad(timeLeft.seconds)}s
          </span>
        </div>
      </div>
    </div>;
}